<template>
  <div>
    <!-- x loggati -->
    <div v-if="user_uid">
      <div v-if="id_asta">
        <Main></Main>
      </div>

      <div v-else>
        <div class="view">
          <v-card width="300">
            <div class="px-8 py-5 d-flex flex-column align-center">
              <img
                class="logo"
                :src="firebase_host + '/static/img/logo_ombra.png'"
              />
              <!-- DA TOGLIERE -->
              <!-- <v-btn depressed outlined color="secondary" class="pa-4 white--text" @click="logout">Logout</v-btn> -->
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <!-- x non loggati -->
    <div v-else>
      <LoginRouter></LoginRouter>
    </div>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Config from "../../../config-app/config";
import authentication from "../../js/auth";
import Main from "./Main";
import LoginRouter from "./LoginRouter";

export default {
  name: "home",
  mixins: [mixins, toast],
  components: { Main, LoginRouter },
  data() {
    return {
      firebase_host: Config.FIREBASE_HOST,
      id_asta: window.firebase ? window.firebase.id_asta : null,
    };
  },

  methods: {
    logout() {
      authentication.signOutUser();
    },
  },

  mounted() {
    console.log("Home mounted.");
  },

  created() {},

  destroyed() {
    console.log("Home destroyed.");
  },
};
</script>

<style scoped lang="scss">

.view {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 100vh;
}
.logo {
  height: 175px;
  margin-top: 15px;
}
</style>
